import { SuperbetRouteConfig } from '@superbet-group/web.types';
import { Route } from 'vue-router';

import { ExpandedEventInUrl } from '@app/enums';
import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import { prematchPage } from '@pages/SportsPage';
import CompetitionPage from '@sportOfferFederation/competitions/CompetitionPage.vue';
import SdsCompetitionBaseHeader from '@sportOfferFederation/competitions/components/SdsCompetitionBaseHeader.vue';
import CompetitionMobileSubnav from '@sportOfferFederation/competitions/components/CompetitionMobileSubnav.vue';
import { AvailableCompetitionTabs } from '@sportOfferFederation/competitions/store/ui/types';
import CompetitionMobileHeader from '@sportOfferFederation/shared/CompetitionMobileHeader.vue';

const competitionLayout = {
    ...prematchPage,
    mobileHeader: CompetitionMobileHeader,
    content: CompetitionPage,
    subnav: SdsCompetitionBaseHeader,
    mobileSubnav: CompetitionMobileSubnav,
};

function getCompetitionLayoutClass(route: Route): string {
    const classes: string[] = [];

    const isEventParamInUrl = route.query[ExpandedEventInUrl.event];
    const isOnOutrightsTab = route.query[ExpandedEventInUrl.competitionTab] === AvailableCompetitionTabs.Outrights;
    const isEventExpanded = isEventParamInUrl && !isOnOutrightsTab;

    if (!isEventExpanded) {
        classes.push('competition-page');
    }

    return classes.join(' ');
}

export const competitionRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Sport.Competition,
        name: RouteName.Sport.Competition,
        isAccessible: Product.Sport,
        components: {
            ...defaultLayout,
            ...competitionLayout,
        },
        meta: {
            title: Title.Sport.Competition,
            layoutClass: getCompetitionLayoutClass,
        },
    },
];
